// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Qdv-","footer":"styles_footer__uvYoa","passCodeTooltip":"styles_passCodeTooltip__VHgTd"};